class BsPdpPromo extends HTMLElement {
    constructor() {
      super(), this.selectors = {
        shareContent: ".bs-promo-modal",
        openBtn: "[data-open-bs-promo]"
      }
    }
    connectedCallback() {
      this.domNodes = queryDomNodes(this.selectors, this);
      const {
        shareContent: e
      } = this.domNodes;
      e && e.innerHTML && (this.shareContent = e.innerHTML, this.init())
    }
    init() {
      this.domNodes.openBtn && this.domNodes.openBtn.classList.remove("m:hidden"), this.modal = new MinimogTheme.Modal, addEventDelegate({
        selector: this.selectors.openBtn,
        handler: e => {
          if (e.preventDefault(), this.shareContent) {
            const e = document.createElement("DIV");
            e.classList.add("bs-promo-content"), e.innerHTML = this.shareContent, this.modal.appendChild(e), this.modal.setSizes("bs-pdp-promo"), this.modal.open()
          }
        }
      })
    }
  }
  customElements.define("bs-pdp-promo", BsPdpPromo);